import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=ad2d3462&scoped=true"
import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=ad2d3462&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2d3462",
  null
  
)

export default component.exports